<!-- =========================================================================================
  File Name: TheNavbar.vue
  Description: Navbar component
  Component Name: TheNavbar
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="relative">
    <div class="vx-navbar-wrapper" :class="classObj">
      <vs-navbar class="p-2 vx-navbar navbar-custom navbar-skelton" :color="navbarColorLocal">
        <vs-row vs-type="flex" vs-w="12">
          <vs-col vs-type="flex" class="sm:inline-flex xl:hidden w-auto">
            <feather-icon class="cursor-pointer" icon="MenuIcon" @click.stop="showSidebar" />
          </vs-col>
          <vs-col vs-type="flex" class="w-auto route-title-div">
            <transition :name="routerTransition">

              <div v-if="$route.meta.breadcrumb || $route.meta.pageTitle"
                class="router-header flex flex-wrap items-center">
                <div class="content-area__heading overflow-dots"
                  :class="{'px-2 border-0 md:border-r border-solid border-grey-light' : $route.meta.breadcrumb}">
                  <span class="weight-600 route-title text-primary overflow-dots">{{ routeTitle }}</span>
                </div>

                <!-- BREADCRUMB -->
                <vx-breadcrumb class="ml-4 d-none lg:block weight-600" v-if="$route.meta.breadcrumb" :route="$route" />
              </div>
            </transition>
          </vs-col>
          <vs-col vs-type="flex" class="w-auto">
            <div class="the-navbar__user-meta flex items-center" style="flex:unset!important">
              <div class="text-right leading-tight hidden sm:block mr-3">
                <p class="font-semibold">{{ user_displayName }}</p>
                <p>{{activeUserInfo.branchName}}</p>
                <small>{{activeUserInfo.rols}}</small>
              </div>
              <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
                <div class="con-img">
                  <img key="onlineImg"
                    :src="logo"
                    alt="user-img" height="40" class="rounded-full shadow-md w-12 mr-4 block px-1 py-1 " />
                </div>
                <vs-dropdown-menu class="vx-navbar-dropdown">
                  <ul style="min-width: 9rem">
                    <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                      @click="$router.push('/pages/profile').catch(() => {})">

                      <feather-icon icon="UserIcon" svgClasses="w-4 h-4" />
                      <span class="ml-2">Profil</span>
                    </li>
                    <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                      @click="$router.push('/apps/email').catch(() => {})">

                      <feather-icon icon="MailIcon" svgClasses="w-4 h-4" />
                      <span class="ml-2">Mesajlar</span>
                    </li>
                    <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                      @click="$router.push('/apps/todo').catch(() => {})">

                      <feather-icon icon="CheckSquareIcon" svgClasses="w-4 h-4" />
                      <span class="ml-2">Görevler</span>
                    </li>
                    <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                      @click="$router.push('/pages/cis').catch(() => {})">

                      <feather-icon icon="CheckSquareIcon" svgClasses="w-4 h-4" />
                      <span class="ml-2">Çalışan İletişim Sistemi</span>
                    </li>
                    <vs-divider class="m-1"></vs-divider>

                    <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="logout">
                      <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
                      <span class="ml-2">Çıkış Yap</span>
                    </li>
                  </ul>
                </vs-dropdown-menu>
              </vs-dropdown>
            </div>
          </vs-col>
        </vs-row>
      </vs-navbar>
    </div>
  </div>
</template>

<script>
  import themeConfig from '@/../themeConfig.js'
  import VxAutoSuggest from '@/components/vx-auto-suggest/VxAutoSuggest.vue';
  import VuePerfectScrollbar from 'vue-perfect-scrollbar'
  import draggable from 'vuedraggable'
  import {removePermissions,removeToken,removeUserDetails} from "@/utils/auth";
import companyInfo from '../../../model/constants/companyInfo';

  export default {
    name: "the-navbar",
    props: {
      navbarColor: {
        type: String,
        default: "#fff",
      },
    },
    data() {
      return {
        logo:companyInfo.logo,

      }
    },
    computed: {
      routeTitle() {
        return this.$route.meta.pageTitle;
      },
      routerTransition() {
        return themeConfig.routerTransition || 'none'
      },
      navbarColorLocal() {
        return this.$store.state.theme === "dark" ? "#10163a" : this.navbarColor
      },
      // HELPER
      verticalNavMenuWidth() {
        return this.$store.state.verticalNavMenuWidth
      },
      windowWidth() {
        return this.$store.state.windowWidth
      },

      // NAVBAR STYLE
      classObj() {
        if (this.verticalNavMenuWidth == "default") return "navbar-default"
        else if (this.verticalNavMenuWidth == "reduced") return "navbar-reduced"
        else if (this.verticalNavMenuWidth) return "navbar-full"
      },

      // PROFILE
      activeUserInfo() {
        return this.$store.state.AppActiveUser
      },
      user_displayName() {
        return this.activeUserInfo.displayName
      },
      activeUserImg() {
        return this.$store.state.AppActiveUser.photoURL;
      }
    },
    methods: {
      showSidebar() {
        this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true);
      },
      selected(item) {
        this.$router.push(item.url).catch(() => {})
        this.showFullSearch = false;
      },
      logout() {
        if (localStorage.getItem("auth-token")) {
          try{
          localStorage.removeItem("auth-token");
          removePermissions();
          removeUserDetails();
          removeToken();
          this.$router.push('/pages/login').catch(() => {})
          }catch(error){
          }
        }
      },
      outside: function () {
        this.showBookmarkPagesDropdown = false
      },
    },
    directives: {
      'click-outside': {
        bind: function (el, binding) {
          const bubble = binding.modifiers.bubble
          const handler = (e) => {
            if (bubble || (!el.contains(e.target) && el !== e.target)) {
              binding.value(e)
            }
          }
          el.__vueClickOutside__ = handler
          document.addEventListener('click', handler)
        },

        unbind: function (el) {
          document.removeEventListener('click', el.__vueClickOutside__)
          el.__vueClickOutside__ = null

        }
      }
    },
    components: {
      VxAutoSuggest,
      VuePerfectScrollbar,
      draggable
    },
  }

</script>
